import React from "react";
import "./Skills.css";
const Skills = () => {
  return (
    <div className="my-5 ">
      <h1 className="my-5 skill-title">Skill Highlights</h1>
      <div className="d-flex container justify-content-center align-items-center ">
        <div className="table table-responsive">
          <tbody>
            <tr>
              <td className="col-1 border  fw-bold">Programming Language</td>
              <td className="col-2 border text-start">
                Python, R, TypeScript, JavaScript, Java, C
              </td>
            </tr>
            <tr>
              <td className="col-1 border fw-bold ">Machine Learning</td>
              <td className="col-2 border text-start">
                Supervised and unsupervised learning, classification and
                regression models, clustering algorithms, Dimensionality
                reduction techniques.
              </td>
            </tr>
            <tr>
              <td className="col-1 border fw-bold ">Deep Learning</td>
              <td className="col-2 border text-start">
                <p>
                  Neural network architectures, Large Language Model,
                  Convolutional Neural Networks for image analysis, Recurrent
                  Neural Netwoeks for sequencing data, Transfer learning
                </p>
              </td>
            </tr>
            <tr>
              <td className="col-1 border fw-bold ">
                Natural Language Processing (NLP)
              </td>
              <td className="col-2 border text-start">
                <p>
                  Text mining and analysis, Sentiment analysis, Named Entity
                  Recognition (NER), Language modeling
                </p>
              </td>
            </tr>
            <tr>
              <td className="col-1 border fw-bold ">Frameworks for AI/ML</td>
              <td className="col-2 border text-start">
                <p>Tensorflow, PyTorch, NLP</p>
              </td>
            </tr>
            <tr>
              <td className="col-1 border fw-bold ">
                Frameworks for Web Development
              </td>
              <td className="col-2 border text-start">
                <p>React, Angular, Next, Nest, Express</p>
              </td>
            </tr>
            <tr>
              <td className="col-1 border fw-bold ">Database Managements</td>
              <td className="col-2 border text-start">
                <p>MySQL, MongoDB</p>
              </td>
            </tr>
            <tr>
              <td className="col-1 border fw-bold ">Tools</td>
              <td className="col-2 border text-start">
                <p>Pandas, NumPy, Matplotlib, Seaborn</p>
              </td>
            </tr>
            <tr>
              <td className="col-1 border fw-bold ">Data Preprocessing</td>
              <td className="col-2 border text-start">
                <p>
                  Feature engineering, Data normalization and scaling Handling
                  missing data, Data augmentation
                </p>
              </td>
            </tr>
            <tr>
              <td className="col-1 border fw-bold ">
                Model Evaluation and Validation
              </td>
              <td className="col-2 border text-start">
                <p>
                  Cross-validation techniques, Hyperparameter tuning, Model
                  evaluation metrics (e.g., accuracy, precision, recall,
                  F1-score)
                </p>
              </td>
            </tr>
            <tr>
              <td className="col-1 border fw-bold ">Big Data Technologies</td>
              <td className="col-2 border text-start">
                <p>Apache Hadoop, Apache Spark</p>
              </td>
            </tr>
          </tbody>
        </div>
      </div>
    </div>
  );
};

export default Skills;
